import * as Icons from "../components/icons";
import { type IconProps } from "../components/icons";
import type { IconName } from "../types/icons";

/**
 * Utility function to get an icon component by its name
 * @param iconName - The name of the icon to retrieve
 * @returns The icon component or undefined if not found
 */
export function getIconComponent(
  iconName: IconName
): React.ComponentType<IconProps> {
  return (Icons as unknown as Record<string, React.ComponentType>)[iconName];
}

export const IconNames = Object.keys(Icons) as IconName[];
